export const labels = {
	title: {
		label: "Label.MobileCreator.UnsupportedBrowser.Title",
		default: "Unsupported browser",
	},
	message: {
		label: "Label.MobileCreator.UnsupportedBrowser.Message",
		default:
			"You are using an unsupported browser please upgrade your browser or continue with another editor.",
	},
	darkModeMessage: {
		label: "Label.MobileCreator.UnsupportedBrowser.DarkMode",
		default:
			"Your browser seems to use dark mode and we can't show your product with the correct colors. Please switch to a light mode or continue with another browser.",
	},
	goToOtherEditor: {
		label: "Label.MobileCreator.UnsupportedBrowser.OtherEditor",
		default: "Other editor",
	},
	goBack: {
		label: "Label.MobileCreator.UnsupportedBrowser.GoBack",
		default: "Go back",
	},
} as const;
